
<template>
	<Window ref="Window" :size="'msg'" :bg="bg" @Close="closeEmpty" class="box">
		<ViewDetail :type="type" ref="ViewDetail"></ViewDetail>
		<newSpecial ref="newSpecial"></newSpecial>
		<!-- 头部开始 -->
		<div slot="headButton" class="dpIB fSub_E hover-f-main_E tra-fast_E">
			<button v-debounce:click="refresh" :title="$t('cmd7',['刷新'])" type="button">
				<Icon name="refresh" class="w1x h1x" :sizeBase="'m'"/>
			</button>
		</div>
		<div slot="head" class="cb">
			<div>
				<div class="dpIB vaM fs14x">{{getLanguageStr('word1949','消息')}}</div>
			</div>
		</div>
		<!-- 头部结束end -->
		<!--一级盒子展示-->
		<div class="tableSys bdSub-top_E vaT_E h100pct bgContent">
			<div class="w40pct message-left"   v-show="!setFlag" scroll fillHeight="lastHeight,-.box .head">
				<ul>
					<li class="pt1x pb1x pl1x pr1x bd_bottom tableSys vaM_E dpIB_E curP" v-for="(item,index) in cateList" :key="index" @click="getSecondaryAlert(item.msgType)">
						<div class="w3x">
							<div class="bgError icoSys h3x w3x">
								<Icon name="status-alarm" class="w1x h1x fWhite" :sizeBase="'m'" />
							</div>
						</div>
						<div class="pl1x" >
							<div><span class="fR cSub">{{item.createDate?isToday(item.createDate):'--'}}</span><span class="fs12x">{{getTypeText(item.msgType,'messageBoxType')}}</span></div>
							<div class="posR">
								<div class="fR errorNum" v-if="item.msgNum>0"> {{item.msgNum>99?'99+':item.msgNum}}</div>
								<div class="textCut cSub mt05x w80pct h012">
									<span>{{$t('fill3rd185',[item.stationName,item.alertName,`电站${item.stationName}发生了${item.alertName}报警`])}}</span>
								</div>
							</div>
						</div>
					</li>
				</ul>
			</div>
			<!--二级盒子展示-->
			<div class="w40pct message-left bgWhite secondLeft"  v-show="setFlag" scroll fillHeight="lastHeight">
				<div class="pl1x cb pt1x pr1x h4x bgWhite cb leftTitle">
					<span class="fR curP mt05x fs12x " @click="goSet" onclick="statistic('A19','A50')" v-permissions="'D/E/A1'" permission-type="none">{{getLanguageStr('word1962','报警消息管理')}}</span>
					<span class="icoSys h2x w2x curP dpB fs12x" @click="showSet">
						<svg class="ico fSub" style="transform: rotate(180deg);"><use xlink:href="#more"></use></svg>
					</span>
				</div>
				<div class="posR" >
					<div class="leftScroll"  fillHeight="lastHeight" scroll>
						<ul class="posR pl1x pr1x">
							<li class="pt1x pb1x pl1x pr1x bd_bottom w100pct vaM_E dpIB_E curP bdLight-bottom" v-for="(item,index) in alertList" :key="index"  @click="getMessageList(item,index)" :class="secondCurrentIndex==index?'bgLight':''" onclick="statistic('A19','A1903')">
								<div class="w100pct">
									<div>
										<span class="fR cSub">{{item.createDate?isToday(item.createDate):'--'}}</span>
										<span class="fs12x textCut dpIB w50pct h012">{{item.alertName}}/ID {{item.alertId}}</span>
									</div>
									<div class="posR">
										<div class="errorNum" v-if="item.msgNum>0">{{item.msgNum>99?'99+':item.msgNum}}</div>
										<div class="textCut cSub mt05x w80pct h012">	
											<span>{{$t('fill3rd185',[item.stationName,item.alertName,`电站${item.stationName}发生了${item.alertName}报警`])}}</span>
										</div>
									</div>
								</div>
							</li>
						</ul>
						<div class="taC" v-show="leftLoad">
						    <div class="icoSys h2x w2x  curP dpIB vaM_E">
								<Icon name="load" class="w1x h1x fPrimary loadBox"/>
							</div>
						</div>
						<div class="tips h4x-lh" v-show="leftBottomTip">{{getLanguageStr('phrase975','没有更多消息')}}</div>
					</div>
				</div>
			</div>
			<div class="w60pct bdLight-left bgDesktop" >
				<div v-if="setFlag&&boxShow">
					<div class="posTitle" >
						<span class="pt1x dpIB fs12x pl2x" >{{chooseAlert.name}}<span v-if="chooseAlert.id!=null">/ID {{chooseAlert.id}}</span></span>
						<span class="icoSys h2x w2x curP dpB fR fs12x mr1x mt05x" @click="goSpecial" v-permissions="'D/E/A1'" permission-type="none">
							<svg class="ico fSub">
								<use xlink:href="#setting"></use>
							</svg>
						</span>
					</div>
					<div class="bdLight-top rightScroll" fillHeight="window,-.box .head,-.box .posTitle" scroll>
						<div class="tips h4x-lh" v-show="rightBottomTip">
							{{getLanguageStr('phrase975','没有更多消息')}}
						</div>
						<div class="taC" v-show="rightLoad">
						    <div class="icoSys h2x w2x  curP dpIB vaM_E">
								<Icon name="load" class="w1x h1x fPrimary loadBox"/>
							</div>
						</div>
						<div>
						<div v-for="(item,index) in messageList" :key="item.messageId" class="rightContent pb2x" >
							<div class="taC pt1x pb1x" v-show="item.timeShow">{{item.alertTime?isToday(item.alertTime):'--'}}</div>
							<ul class="pl2x pr2x ">
									<li class="pl2x pr2x lh20 pt1x panel bgPanel  pb1x curP" @click.stop="showAlert(item)" onclick="statistic('A19','A37')">
										<div class="fs12x cb">
											<span class="dpIB w80pct">
												<span>{{$t('fill3rd185',[item.stationName,item.showName,`电站${item.stationName}发生了${item.showName}报警`])}}</span>
											</span>
											<span class="icoSys h2x w2x dpB fR">
												<svg class="ico fSub"><use xlink:href="#more"></use></svg>
											</span>
										</div>
										<div><span class="mr05x cSub">{{getLanguageStr('word1960','报警设备')}}:</span>{{item.deviceSN}}</div>
										<div><span class="mr05x cSub">{{getLanguageStr('word1745','报警名称')}}:</span>{{item.showName}}/ID {{item.alertId}}</div>
										<div><span class="mr05x cSub">{{getLanguageStr('word115','等级')}}:</span>
											<span class="cPrimary" v-if="item.level==0">{{getTypeText(item.level,'alarmLevelFilter')}}</span>
											<span class="cWarning" v-else-if="item.level==1">{{getTypeText(item.level,'alarmLevelFilter')}}</span>
											<span class="cError" v-else>{{getTypeText(item.level,'alarmLevelFilter')}}</span>
										</div>
										<div><span class="mr05x cSub">{{getLanguageStr('word1481','影响范围')}}:</span>{{getTypeText(item.infulence,'alarmFilterScope')}}</div>
										<div>{{getLanguageStr('phrase973','建议您排查下具体原因')}}</div>
									</li>
								</ul>
							</div>
							</div>
					</div>
				</div>
				<div class="tableSys h100pct taC vaM_E" v-else>
					<div>
						<Icon name="email" class="w7x h7x fLight" :sizeBase="'m'" />
					</div>
				</div>
			</div>
		</div>
		<div ref="view"></div>
	</Window>
</template>
<script>
import * as lib from '@/util/lib'
import Window from '@/components/common/ui/WindowForView.vue'
import Loading from '@/components/common/ui/Loading'
import NoResult from '@/components/common/ui/NoResult'
import StatusIco from '@/components/common/ui/StatusIco'
import InputText from '@/components/common/ui/InputText'
import ViewDetail from "@/view/maintain/alarm/part/ViewDetail.vue";
import { getLanguageStr } from '@/util/language'
import * as maintainApi from '@/api/maintain/alarm/list.js'
import newSpecial from '@/view/manage/message/part/NewSpecial.vue'
// import DeviceDetail from '@/view/device/device/ViewDetail.vue'
import {getMsgCategory,getSecondaryList,getAlertMsgChange,messageAlertList,judgeSpecialRules,getSpecialById} from '@/api/manage/message.js'
export default {
	name: 'box',
	components: {
		Loading,
		NoResult,
		Window,
		InputText,
		ViewDetail,
		newSpecial,
		// DeviceDetail
	},
	props: {
		bg: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			stage,
			clicks: true,
			pagination: {}, 
			setFlag:false,
			boxShow:false,
			cateList:[],
			alertList:[],
			msgType:'ALERT',
			messageList:[],
			paginationList:{},
			type:2,
			chooseAlert:{
				name:getLanguageStr('word27','报警'),
				id:null
			},
			leftAlert:{
				startPage: 1,
				pageSize: 50//50
			},
			leftTotal:0,
			rightAlert:{
				startPage: 1,
				pageSize:20//20
			},
			leftFlag:true,
			leftLoad:false,
			leftBottomTip:false,
			secondCurrentIndex:null,
			rightBottomTip:false,
			rightTotal:0,
			lastRight:false,
			rightFlag:true,
			rightLoad:false,
			leftContentheight:0,

		}
	},
	methods: {
		getLanguageStr,
		getTypeText: lib.getTypeText,
		timeFormat: lib.timeFormat,
		isToday(str) {
				str=str*1000
				if (new Date(str).toDateString() === new Date().toDateString()) {
					//今天
					return this.timeFormat(str/1000,'system','%H:%M')
				} else if (new Date(str) < new Date()){
					//之前
					return this.timeFormat(str/1000,'system','%Y/%m/%d %H:%M')
				}
		},
		showAlert(item){
			maintainApi.baseInfoGet({
	          deviceId: item.deviceId,
	          language: stage.languageId,
	          ruleId: item.alertId
		        }).then(res => {
		          this.$refs.Window.loadStatusAction(false)
				  this.detailInfo = res
				  this.detailInfo.alertTime=item.alertTime;
		          this.detailInfo.timezone=item.timeZone
		          this.$refs.ViewDetail.show(this.detailInfo,'plant')
				})
		},
		// showDevice(detailInfo){	//在本层呈现设备详情，关闭设备详情会导致报警详情windows的z-index失去独立层叠上下文，被总导航覆盖（移至报警详情的window中）
		// 	detailInfo.siteId=detailInfo.plantId;
		// 	this.$dynamic(this.$refs.view,DeviceDetail, {bg: true,type:2}, {
		// 	}, {}).then(({instance, childInstance}) => {
		// 		let dec = 1
		// 		if (detailInfo.deviceType === 'COLLECTOR') {
		// 			dec = 1
		// 		} else {
		// 			dec = 2
		// 		}
		// 		childInstance.show(detailInfo, '', instance, dec)
		// 	})
		// },
		getSpecialById(id){
			getSpecialById(id).then(response => {
        statistic('A19','A69')
				this.$refs.newSpecial.open(response,'edit')
				}, error => {
			  !_.isEmpty(error) && this.$notify(error)
			})
		},
		goSpecial(){
			judgeSpecialRules(this.chooseAlert.id).then(res => {
				if(res.exists){
					 this.getSpecialById(res.ruleId);
				}else{
					if(res.ruleNum>10){
						this.$notify(getLanguageStr('phrase966', '每个商家最多10个特殊规则'))
					}else{
            statistic('A19','A68')
						this.$refs.newSpecial.open(this.chooseAlert,'add')
					}
				}
			}, error => {
			  !_.isEmpty(error) && this.$notify(error)
			})
		},
		goSet(){
			this.$refs.Window.hide()
			this.$router.push('/manage/message');
		},
		showSet(){
			this.leftAlert.startPage=1
			this.alertList=[]
			this.setFlag=!this.setFlag;
			if(this.setFlag==false){
				this.getC()
			}
		},
		//获取二级弹窗
		getSecondaryAlert(v){
			if(v=='ALERT'){
				statistic('A19','A1902')
			}
			this.$nextTick(()=>{
				this.setFlag=true;
			});
			this.loadLeftData();
		},
		moreLeftData() {
			let t=this.leftAlert.startPage*this.leftAlert.pageSize
			if(t<this.leftTotal&&t<1000) { //判断是否继续上拉刷新
				this.leftBottomTip = false;
				this.leftAlert.startPage= this.leftAlert.startPage+ 1
				this.loadLeftData() //获取数据方法   
			} else {
				this.leftBottomTip = true;
				return false
			}
		},
		loadLeftData() {
			this.leftLoad=true;
			let queryParam = {
				page: this.leftAlert.startPage,
				size: this.leftAlert.pageSize
			   }
			let copyCond = {msgType:this.msgType}
			let queryData = {...copyCond, ...queryParam}
			getSecondaryList(queryData).then(res => {
				this.leftLoad=false
				this.leftTotal=res.total
				if(res.messageCapsule.length<this.leftAlert.pageSize){
					 this.leftBottomTip = true;
				}
				
				res.messageCapsule.forEach(item=>{
					this.alertList.push(item)
				})
				//this.alertList =this.alertList.concat(res.messageCapsule)
				setTimeout(() => { this.leftFlag=true; }, 200);//防止多次滑动
				this.$nextTick(()=>{
				lib.fillHeight()
				var self = this;
				var leftGundong=0;
				this.leftContentheight=Math.floor($(".leftScroll").find("li").outerHeight()*this.leftAlert.pageSize* this.leftAlert.startPage)-$('.leftScroll').height();
				lib.setScroll($(this.$el).find(".leftScroll[scroll]"), {whileScrolling:()=>{
					  leftGundong=Math.abs(parseFloat($(".leftScroll").children().children().css("top")));
					  if(leftGundong>=this.leftContentheight&&this.leftFlag){
					  	this.leftFlag=false;
					  	self.moreLeftData();
					  }else{
					  	return
					  }
						trace(this)
					}});
				})
			}, error => {
				this.leftLoad=false
				!_.isEmpty(error) && this.$notify(error)
			})	
		},
		getMessageList(item,index){
			if(this.clicks){
				this.clicks=false
				item.msgNum=0;//点击以后去掉这行的未读显示
				this.secondCurrentIndex=index
				this.boxShow=true
				this.chooseAlert={
					id:item.alertId,
					name:item.alertName
				}
				getAlertMsgChange({alertId:item.alertId,msgType:item.msgType}).then(res => {
					this.$bus.$emit('changeUnread')
				}, error => {
					!_.isEmpty(error) && this.$notify(error)
				})
				//获取盒子右侧内容
				this.rightAlert.startPage=1;
				this.messageList=[]
				this.getMessageContent()
			}
		},
		moreRightData() {
			let t=this.rightAlert.startPage*this.rightAlert.pageSize
			if(t<this.rightTotal&&this.rightAlert.startPage<50) { //判断是否继续上拉刷新
				this.rightBottomTip = false;
				this.rightAlert.startPage=this.rightAlert.startPage+1
				this.getMessageContent() //获取数据方法   
				return false
			} else {
				this.rightBottomTip = true;
				this.lastRight=true
				return false
			}
		},
		getMessageContent(){
			this.rightLoad=true;
			 let queryParam = {
				'order.direction':'DESC',
				'order.property':'created_date',
				page: this.rightAlert.startPage,
				size: this.rightAlert.pageSize,
			}
			 if(this.boxShow){
			 	messageAlertList(queryParam,this.chooseAlert.id).then(res => {
				this.rightLoad=false;
			 	this.clicks=true
				setTimeout(() => { this.rightFlag=true; }, 200);//防止多次滑动
				this.rightTotal=res.total
				var len=res.data.length;
				if(res.data.length>1){
					for(let i=1;i<=res.data.length;i++){
						for(let i=1;i<=res.data.length;i++){
							if(i==res.data.length){
								if(this.isToday(res.data[i-2].alertTime)===this.isToday(res.data[i-1].alertTime)){
									this.$set(res.data[i-1],'timeShow',false)
								}else{
									this.$set(res.data[i-1],'timeShow',true)
								}
							}else{
								if(this.isToday(res.data[i-1].alertTime)===this.isToday(res.data[i].alertTime)){
									this.$set(res.data[i-1],'timeShow',false)
								}else{
									this.$set(res.data[i-1],'timeShow',true)
								}
							}
						}
					}
				}else if(res.data.length==1){
					this.$set(res.data[0],'timeShow',true)
				}
				res.data.forEach((item,index)=>{
					this.messageList.unshift(item)
				})
				this.$nextTick(()=>{
				lib.fillHeight()
				var rightGundong=0,rightContentheight=0;
				var self=this;
				var f=0;
				lib.setScroll($(this.$el).find(".rightScroll[scroll]"), {whileScrolling:()=>{
					 rightGundong=Math.abs(parseFloat($(".rightScroll").children().children().css("top")));
					  if(rightGundong==0&&this.rightFlag){
					  	this.rightFlag=false
					  	self.moreRightData();
					  }else{
					  	return
					  }
					trace(this)
					}
				});
				if(this.rightAlert.startPage==1){
						$('.rightScroll').mCustomScrollbar("scrollTo","bottom",{
					    scrollInertia:0
						});
					}
				else{
					f=Math.floor($(".rightScroll").find(".rightContent").outerHeight()*(len))
					$('.rightScroll').mCustomScrollbar("scrollTo",`-${f}px`,{//`-${f}px`
				  		    scrollInertia:0
					});
				}
			});
			}, error => {
				this.rightLoad=false
				!_.isEmpty(error) && this.$notify(error)
			})	
			 }
		
		},
		//一级盒子
		getC(){
			getMsgCategory().then(res => {
				if(res instanceof  Array){
					this.cateList = res
				}
				this.$nextTick(function () {
				   lib.fillHeight()
				})
			}, error => {
				!_.isEmpty(error) && this.$notify(error)
			})
		},
		show () {
			this.leftAlert.startPage=1;
			this.rightAlert.startPage=1;
			this.setFlag=false
			this.getC();
			this.$refs.Window.show()
			this.$refs.Window.loadStatusAction(false)
		},
		hide () {
			this.$refs.Window.hide()
		},
		closeEmpty(){
			this.alertList=[]
			this.messageList=[]
			this.boxShow=false
			this.setFlag=false
			this.secondCurrentIndex=null
		},
		refresh () {
			this.alertList=[]
    		this.messageList=[]
			if(this.setFlag){
				this.leftAlert.startPage=1;
				this.rightAlert.startPage=1;
				this.getSecondaryAlert();
				this.getMessageContent();
			}else{
				this.getC();
			}
			this.$refs.Window.loadStatusAction(true)
			this.$refs.Window.show()
			this.$refs.Window.loadStatusAction(false)
		},
		setting () {
			this.$emit('setting')
			this.$refs.Window.hide()
		}
	},
	mounted () {
		lib.fillHeight()
	}
}
</script>
<style lang="scss" scoped>
.window > .body {
  padding-bottom: 0;
}
.head {
  background: #fff;
}
.errorNum{
	display: inline-block;
	position: absolute;
	background: red;
	color: #fff;
	right: 0;
	top: 0;
	padding:3px;
	font-size: 12px;
	line-height: 12px;
	border-radius: 9px;
	min-width: 12px;
	text-align: center;
	box-sizing: content-box;
}
.wrapper {
	position: absolute;
	top: 0;
	bottom: 0;
	z-index: 1;
	height: 100%;
	width: 100%;
}
.z-index100{
	z-index: 100;
}
.z-index5{
	z-index: 5;
}
.posTitle{
	height: 4em;
}
.tips{
	text-align: center;
}
.h012{
	height: 1.2em;
}
.loadBox{
	animation:rotate 3s linear infinite;
}
</style>



// WEBPACK FOOTER //
// src/view/manage/message/Box.vue